"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStepTitleSubTitle = exports.StyledStepTitle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
const Text_1 = require("../../../Text");
const CSSLink = (0, styled_components_1.css) `
    outline: none;

    &,
    &:focus,
    &:hover {
        text-decoration: none;
    }
`;
exports.StyledStepTitle = (0, styled_components_1.default)(Text_1.Text) `
    a {
        font-size: ${helpers_1.FONT_SIZE_XL};
        ${CSSLink}
    }
`;
exports.StyledStepTitleSubTitle = (0, styled_components_1.default)(Text_1.Text) `
    a {
        ${CSSLink}
    }
`;
//# sourceMappingURL=StepTitle.styles.js.map